import { Button, CircularProgress } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useTranslation } from "react-i18next";

interface SummarizeButtonProps {
  onClick: () => void;
  isPending: boolean;
  hasTranscript: boolean;
  disabled?: boolean;
}

export function SummarizeButton({
  onClick,
  isPending,
  hasTranscript,
  disabled = false,
}: Readonly<SummarizeButtonProps>) {
  const { t } = useTranslation(["summary"]);

  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={isPending || disabled}
      startIcon={
        isPending ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <AutoAwesomeIcon />
        )
      }
      sx={{
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        color: "white",
        textTransform: "none",
        fontWeight: 600,
        "&:hover": {
          background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
        },
        "&:disabled": {
          background: "linear-gradient(135deg, #a5b4fc 0%, #c4b5fd 100%)",
          color: "rgba(255,255,255,0.7)",
        },
      }}
    >
      {hasTranscript
        ? t("summary:summarize")
        : t("summary:transcribeAndSummarize")}
    </Button>
  );
}
